import checkCanStore from "./check-can-store.js";

export default {
	checkCanStore,
};
